import { useEffect } from "react";
import { useNotificationWebSocket } from "../../hooks/notifications/useNotificationWebSocket";
import { useNotificationsApi } from "../../hooks/notifications/useNotificationsApi";

interface NotificationCountProps {
  communityId: number;
  communityMemberId: number;
}

export const NotificationCount = ({
  communityId,
  communityMemberId,
}: NotificationCountProps) => {
  const {
    newNotificationCount,
    fetchNewNotificationsCount,
    onNotificationEventReceive,
  } = useNotificationsApi();

  useEffect(() => {
    void fetchNewNotificationsCount(communityId);
  }, []);

  useNotificationWebSocket(communityMemberId, onNotificationEventReceive);

  if (newNotificationCount) {
    return <span className="notifications__count">{newNotificationCount}</span>;
  }
  return null;
};
